export enum CONFIGPARAMTYPES {
  Range = 'range',
  Value = 'value',
  Numerical = 'numerical',
  NumericalColorScheme = 'numericalColorScheme',
  DiscreteColorScheme = 'discreteColorScheme',
  Boolean = 'boolean',
  MultipleChoice = 'multipleChoice',
  String = 'string',
  Text = 'text',
  JSON = 'JSON',
}

export function createConfigParamTypeRange(minVal: number, maxVal: number, step: number, defaultValue: number) {
  return {
    configParamTypeId: CONFIGPARAMTYPES.Range,
    minVal,
    maxVal,
    step,
    defaultValue,
  };
}

export function createConfigParamMultipleChoice(choices: { id: string; name: string }[]) {
  return {
    configParamTypeId: CONFIGPARAMTYPES.MultipleChoice,
    choices,
    defaultValue: choices[0].id,
  };
}

export function createConfigParamCountPicker(values: number[], defaultValue: number) {
  const choices = values.map((value) => ({ id: String(value), name: value }));
  return {
    configParamTypeId: CONFIGPARAMTYPES.MultipleChoice,
    choices,
    defaultValue: String(defaultValue),
  };
}

export function createConfigParamBoolean(defaultValue: boolean) {
  return {
    configParamTypeId: CONFIGPARAMTYPES.Boolean,
    defaultValue,
  };
}

export function createConfigParamLabelSpace(defaultValue: number = 5) {
  return createConfigParamTypeRange(1, 10, 0.5, defaultValue);
}

export function getLabelSpaceSize(configParam: number) {
  return Math.round((120 * 2 ** (configParam / 5)) / 2 ** (5 / 5));
}

export function createConfigParamTypeDiscreteColorScheme() {
  return {
    configParamTypeId: CONFIGPARAMTYPES.DiscreteColorScheme,
    defaultValue: 'Default',
  };
}

export function createConfigParamTypeNumericalColorScheme() {
  return {
    configParamTypeId: CONFIGPARAMTYPES.NumericalColorScheme,
    defaultValue: 'Default',
  };
}
